import React from 'react';

import { EditAccountingFirmGeneralSettingsContext } from './EditGeneralSettingsContext';

const useAccountingFirmEditGeneralSettingsContext = () => React.useContext(EditAccountingFirmGeneralSettingsContext);

export { useAccountingFirmEditGeneralSettingsContext };
